import { render } from "./CliClientesView.vue?vue&type=template&id=3fbaae64&scoped=true"
import script from "./CliClientesView.vue?vue&type=script&lang=js"
export * from "./CliClientesView.vue?vue&type=script&lang=js"

import "./CliClientesView.vue?vue&type=style&index=0&id=3fbaae64&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Garantidoras\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbaae64"]])

export default __exports__